/* tslint:disable */
/* eslint-disable */
export enum WorkFiDeltaNEnum {
  $30 = '30',
  $300 = '300'
}
